import React from 'react'

export default function Hero({posts}) {

    let heroPost = posts[Math.floor(Math.random() * posts.length)];
    console.log('hero post', heroPost);

  return (
    <div className="w-full full">
        <div className="mxw-sm w-full my-12 relative">
            <h2 className="text-4xl md:text-6xl lg:text-6xl font-bold gradient__text">Blog.</h2>
            {/* <span className="text-slate-300 absolute -top-10 left-0 -z-10 text-9xl font-bold">Folio</span> */}
        </div>
    </div>
  )
}
